import gql from 'graphql-tag';

const ACV_ESTIMATES_FRAGMENT = gql`
  fragment AcvEstimatesFragment on AcvEstimates {
    post_inspection {
      ...PostInspectionFragment
    }
  }
`;

export default ACV_ESTIMATES_FRAGMENT;
